import { render, staticRenderFns } from "./TeamCreate.vue?vue&type=template&id=863c0c6e&"
import script from "./TeamCreate.vue?vue&type=script&lang=ts&"
export * from "./TeamCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports